module.exports = __webpack_public_path__ + "img/take.e8875aa1.png";